import React from "react";

class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Erreur d'affichage de l'application :", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="flex min-h-screen flex-col items-center justify-center bg-[#F6F7F1] px-6 text-center">
          <h1 className="font-playfair text-3xl font-bold text-gray-900">
            Cette page rencontre un problème
          </h1>
          <p className="mt-3 max-w-lg text-gray-600">
            Rechargez le site pour réessayer. Si le problème persiste, contactez-nous.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-6 rounded-full bg-[#E5007D] px-6 py-3 font-medium text-white hover:bg-[#c7006b]"
          >
            Recharger le site
          </button>
        </main>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
